import {
  apiClient,
  type PageEntity,
  type PartnerSelectEntity
} from '@/libs/api'
import { type PartnersSelectQuery } from '@/libs/api/types'

export type FetchPartnersSelectResponse = {
  data: PartnerSelectEntity[]
  pagination: PageEntity | null
}

/**
 * パートナー選択用検索API
 * インクリメンタルサーチ対応
 */
export const fetchPartnersSelect = async (
  tenantKey: string,
  query: PartnersSelectQuery,
  signal?: AbortSignal
): Promise<FetchPartnersSelectResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .partners.select.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
